import classNames from "classnames";
import { FC, ReactElement } from "react";

import Header from "widgets/Header";

type Props = {
  title?: string;
  description?: ReactElement | string;
  isBackButton?: boolean;
  backButtonLink?: string;
  children?: ReactElement;
  actions?: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
};

const PageTemplate: FC<Props> = ({
  title,
  description,
  isBackButton,
  backButtonLink,
  children,
  actions,
  className,
  wrapperClassName,
}) => {
  return (
    <div className={classNames("page-template", wrapperClassName)}>
      <Header
        title={title}
        actions={actions}
        description={description}
        isBackButton={isBackButton}
        backButtonLink={backButtonLink}
      />

      <main className={className}>{children}</main>
    </div>
  );
};

export default PageTemplate;
